import React from "react";

function CombatFeature() {
  return (
    <div>
      <section className="combat-feature">
        <div className="container">
          <div className="combat-feature-content">
            <h2 className="combat-feature-title futuraPTBold">
              Where the Action
              <br />
              Never Stops.
            </h2>

            <p className="combat-feature-text">
              Experience the intensity of live combat sports and high-energy
              entertainment at ADS Sports Complex. From professional wrestling and
              MMA fight nights to boxing exhibitions and specialty sporting events,
              our venue brings fans closer to the action. Feel every entrance, every
              takedown, and every championship moment in an atmosphere built for
              unforgettable experiences.
            </p>

            <a href="/#upcoming-events" className="btn combat-feature-button">
              View Upcoming Sporting Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CombatFeature;
